/**
Author - Babajan khan
Github - https://www.github.com/babajanpatan/
**/

import React, {useState, useEffect} from "react";
import {useRouter} from "next/router";

import Navbar from "./Header";

const HeaderConatiner = () => {
  const [scrollPosition, setScrollPosition] = useState(0);
  const router = useRouter();

  const handlePush = () => {
    router.push("/");
  };

  useEffect(() => {
    window.onscroll = function () {
      setScrollPosition(window.scrollY);
    };
  }, []);

  return (
    <Navbar
      handlePush={handlePush}
      scrollPosition={scrollPosition}
    />
  );
};

export default HeaderConatiner;
